import { render, staticRenderFns } from "./FooterFirst.vue?vue&type=template&id=0b8e96c8&scoped=true&"
import script from "./FooterFirst.vue?vue&type=script&lang=js&"
export * from "./FooterFirst.vue?vue&type=script&lang=js&"
import style0 from "./FooterFirst.vue?vue&type=style&index=0&id=0b8e96c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e96c8",
  null
  
)

export default component.exports